import { useState } from "react";
import TopNav from "../common/topnav";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../http/authcontex";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../loading/loading";
import Select from "react-select";
import SideNave from "../common/sidenav";
import "./report.css";
import {
  weeklyReport,
  zoneWiseReport,
  quarterlyReport,
  quarterlyNewBusinessReport,
  timesheetReport,
  zonewiseActivityTrackerReport,
  zonewiseTargetAchievementReport
} from "../http/api";

export default function Report() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const authContext = useAuth();

  const { userRoles } = useAuth();

  console.log("Resolved Role:", userRoles);
  const isManager = userRoles === "MGR";
  const isAdmin = userRoles === "ADMIN";
  const isExecutive = userRoles === "EXE";

  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(
    localStorage.getItem("sidebarCollapsed") === "true",
  );

  const [reportType, setReportType] = useState("");
  const [financialYear, setFinancialYear] = useState("2025-26");
  const [reportDate, setReportDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // yyyy-MM-dd for input[type="date"]
  });

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const financialYearOptions = [
    { value: "2026-27", label: "2026-27" },
    { value: "2025-26", label: "2025-26" },
  ];

  let reportTypeOptions = [{ value: "", label: "Select Report Type" }];

  if (isManager || isAdmin) {
    reportTypeOptions.push(
      // { value: "Weekly_Report", label: "Weekly Summary Report" },
      // { value: "Weekly_Zonewise_Report", label: "Weekly Zonewise Report" },

      {
        value: "Zonewise_Target_Achievement",
        label: "Zone-wise Target vs Achievement Report",
      },
      {
        value: "Zonewise_Activity_Tracker",
        label: "Zone-wise Activity Tracking Report",
      },
      {
        value: "Quarterly_Zonewise_Report_Ongoing",
        label: "Quarterly Zonewise Report (Ongoing)",
      },
      {
        value: "Zonewise_Report_New_Business",
        label: "Zonewise Report (New Business)",
      },
      { value: "Timesheet", label: "Timesheet" },
    );
  } else if (isExecutive) {
    reportTypeOptions.push({ value: "Timesheet", label: "Timesheet" });
  }

  console.log("userRoles from context:", userRoles);

  const handleReportTypeChange = (selectedOption) => {
    setReportType(selectedOption ? selectedOption.value : "");
  };

  const handleFinancialYearChange = (selectedOption) => {
    setFinancialYear(selectedOption ? selectedOption.value : "2026-27");
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`; // dd/MM/yyyy
  };

  console.log("User Role:", userRoles);

  const handleSubmit = () => {
    const allowedReports =
      isManager || isAdmin
        ? [
            "Weekly_Report",
            "Weekly_Zonewise_Report",
            "Quarterly_Zonewise_Report_Ongoing",
            "Zonewise_Report_New_Business",
            "Zonewise_Activity_Tracker",
            "Timesheet",
            "Zonewise_Target_Achievement"
          ]
        : ["Timesheet"]; // Executive only

    if (!allowedReports.includes(reportType)) {
      toast.error("You are not authorized to download this report", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    if (reportType === "Timesheet") {
      if (!startDate || !endDate) {
        toast.error("Please select both start and end dates", {
          position: "top-right",
          autoClose: 3000,
        });
        return;
      }

      setLoading(true);
      const fileDate = new Date().toISOString().split("T")[0];
      const currentTime = new Date()
        .toTimeString()
        .split(" ")[0]
        .replace(/:/g, "-");

      timesheetReport(startDate, endDate)
        .then((response) => {
          setLoading(false);
          const byteArray = new Uint8Array(response.data);
          const blob = new Blob([byteArray], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `Timesheet_${startDate}_to_${endDate}_${fileDate}_${currentTime}.xlsx`;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          toast.success("Timesheet report downloaded!", {
            position: "top-right",
            autoClose: 3000,
          });
        })
        .catch((error) => {
          setLoading(false);
          if (error.response && error.response.status === 401) {
            authContext.logout();
            navigate("/");
          } else {
            toast.error("Failed to download timesheet report.", {
              position: "top-right",
              autoClose: 3000,
            });
          }
        });

      return;
    }

    if (!reportDate) {
      toast.error("Please select a report date", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    setLoading(true);

    const formattedDate = formatDate(reportDate);
    const fileDate = reportDate.replace(/-/g, "-");
    const currentTime = new Date()
      .toTimeString()
      .split(" ")[0]
      .replace(/:/g, "-");

    let apiCall;

    if (reportType === "Weekly_Zonewise_Report") {
      apiCall = zoneWiseReport(
        financialYear,
        encodeURIComponent(formattedDate),
      );
    } else if (reportType === "Quarterly_Zonewise_Report_Ongoing") {
      apiCall = quarterlyReport(
        financialYear,
        encodeURIComponent(formattedDate),
      );
    } else if (reportType === "Zonewise_Report_New_Business") {
      apiCall = quarterlyNewBusinessReport(
        financialYear,
        encodeURIComponent(formattedDate),
      );
    } else if (reportType === "Zonewise_Target_Achievement") {
      apiCall = zonewiseTargetAchievementReport(
        financialYear,
        encodeURIComponent(formattedDate),
      );
    } else if (reportType === "Zonewise_Activity_Tracker") {
      apiCall = zonewiseActivityTrackerReport(
        financialYear,
        encodeURIComponent(formattedDate),
      );
    } else {
      apiCall = weeklyReport(financialYear, encodeURIComponent(formattedDate));
    }

    apiCall
      .then((response) => {
        setLoading(false);
        if (response.status === 200) {
          const byteArray = new Uint8Array(response.data);
          const contentType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          const blob = new Blob([byteArray], { type: contentType });

          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);

          const filename = `${reportType.replace(/ /g, "")}_${financialYear}_${fileDate}_${currentTime}.xlsx`;

          link.download = filename;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          toast.success("Report generated successfully!", {
            position: "top-right",
            autoClose: 3000,
          });
        } else {
          toast.error("Failed to generate the report. Please try again.", {
            position: "top-right",
            autoClose: 3000,
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        if (error.response && error.response.status === 401) {
          authContext.logout();
          navigate("/");
        } else {
          toast.error("Error generating report. Please try again later.", {
            position: "top-right",
            autoClose: 3000,
          });
        }
      });
  };

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className="Reports">
      {loading && <Loading />}
      <div className={`sb-nav-fixed ${isSidebarCollapsed ? "collapsed" : ""}`}>
        <TopNav toggleSidebar={toggleSidebar} />
        <div id="layoutSidenav">
          <SideNave
            isSidebarCollapsed={isSidebarCollapsed}
            toggleSidebar={toggleSidebar}
          />
          <div id="layoutSidenav_content">
            <main>
              <div className="container-fluid px-4">
                <h4 className="mt-4">Report</h4>
                <hr className="bg-warning" style={{ height: "4px" }} />
                <div
                  className="card mb-4"
                  style={{ maxWidth: "700px", margin: "0 auto" }}
                >
                  <div className="card-body shadow-sm border-0">
                    {/* Report Type Dropdown */}
                    <div className="mb-3">
                      <label htmlFor="reportType" className="form-label">
                        Report Type
                      </label>
                      <Select
                        id="reportType"
                        value={
                          reportType
                            ? { value: reportType, label: reportType }
                            : null
                        }
                        onChange={handleReportTypeChange}
                        options={reportTypeOptions}
                        placeholder="Select Report Type"
                        isDisabled={loading}
                      />
                    </div>

                    {reportType !== "Timesheet" ? (
                      <>
                        {/* Financial Year */}
                        <div className="mb-3">
                          <label htmlFor="financialYear" className="form-label">
                            Financial Year
                          </label>
                          <Select
                            id="financialYear"
                            value={
                              financialYear
                                ? { value: financialYear, label: financialYear }
                                : null
                            }
                            onChange={handleFinancialYearChange}
                            options={financialYearOptions}
                            placeholder="Select Financial Year"
                            isDisabled={loading}
                          />
                        </div>

                        {/* Report Date */}
                        <div className="mb-3">
                          <label htmlFor="reportDate" className="form-label">
                            Report Date
                          </label>
                          <input
                            type="date"
                            id="reportDate"
                            className="form-control"
                            value={reportDate}
                            onChange={(e) => setReportDate(e.target.value)}
                            disabled={loading}
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        {/* Start Date */}
                        <div className="mb-3">
                          <label htmlFor="startDate" className="form-label">
                            Start Date
                          </label>
                          <input
                            type="date"
                            id="startDate"
                            className="form-control"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            disabled={loading}
                          />
                        </div>

                        {/* End Date */}
                        <div className="mb-3">
                          <label htmlFor="endDate" className="form-label">
                            End Date
                          </label>
                          <input
                            type="date"
                            id="endDate"
                            className="form-control"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            disabled={loading}
                          />
                        </div>
                      </>
                    )}

                    <button
                      className="btn btn-primary w-100"
                      onClick={handleSubmit}
                      disabled={
                        loading ||
                        !reportType ||
                        (reportType !== "Timesheet" && !reportDate) ||
                        (reportType === "Timesheet" && (!startDate || !endDate))
                      }
                    >
                      {loading ? "Generating..." : "Generate Report"}
                    </button>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}
